// extracted by mini-css-extract-plugin
export default {"personalInfoContainer":"PersonalInfo_personalInfoContainer__7tIcH","saveBtn":"PersonalInfo_saveBtn__dXzWj","subtext":"PersonalInfo_subtext__B8eUV","text":"PersonalInfo_text__Z92Jr"};